module.exports = __webpack_public_path__ + "assets/img/projects_item_bgimg_right.f7c361fd.png";